import type { HeatmapHighlight, HeatmapHighlightsListItem } from './heatmap/dto';
import type { RecordingHighlight, RecordingHighlightsListItem } from './recording/dto';
import type { GenericHighlightsListItem } from './common/dto';

/* eslint-disable camelcase */

export type Highlight = HeatmapHighlight | RecordingHighlight;

export interface HighlightFilters {
  date_from: string | undefined;
  date_to: string | undefined;
  label_ids: Array<number>;
  types: Array<string>;
  user_ids: Array<number>;
  solved_status?: string;
  page: number;
  items_per_page: number;
}

interface UnknownHighlightsListItem extends GenericHighlightsListItem {
  type: 'unknown';
  metadata: Record<string, never>;
}

export type HighlightsListItem =
  | HeatmapHighlightsListItem
  | RecordingHighlightsListItem
  | UnknownHighlightsListItem;

export enum HighlightsEventType {
  HIGHLIGHT_SHARED = 'highlight-shared',
  HIGHLIGHT_DOWNLOADED = 'highlight-downloaded',
  HIGHLIGHT_VIEWED = 'highlight-viewed',
}

export interface UnseenCount {
  unseen_count: number;
}

export interface HighlightEventMetadata {
  highlight_area?: string;
  ui_position?: string;
}

export type { GenericHighlight } from './common/dto';

export type { HeatmapHighlight } from './heatmap/dto';

export type { RecordingHighlight } from './recording/dto';
